export const subtitleText =
    'Check your inbox for a password reset link. Be sure to check your spam folder just in case.';
export const titleText = 'We found your account in our system';
export const backToLoginText = 'Back to login page';
